// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"25fd9956","248":"ae34a168","291":"2e9a64b3","523":"e285d91b","579":"2b710a27","650":"d443c808","715":"7fafc800","745":"e148301c","920":"34828f78"}[chunkId] + ".chunk.js";
};